const  projectsPHP = [
    {
       proTitle: "PHP projects", 
       projectProps: [
            {
                title: "PHP and MySQL",
                img: "./img_projects/php/project1.png",
                desc: "Web app based on data from MySQL database with CSS style and jQuery/AJAX.",
                long_desc: `Application for the sale of agricultural products on reservation.
                <p>The software layouts the data it obtains from AJAX and MySQL databases using CSS.</p>`,
                topics: "PHP, AJAX, CSS/HTML, MySQL, jQuery, Javascript",
                location_url: "./web_app/projects/php/savio_sito/index.php",
                source_code: false
            },
            {
                title: "Pizzeria web site",
                img: "./img_projects/php/project2.png",
                desc: "Application built on data from MySQL database with CSS style and jQuery/AJAX.",
                long_desc: `Showcase application showing the products for sale of a pizzeria.
                Gets the data to build the layout from database.`,
                topics: "PHP, AJAX, CSS/HTML, MySQL, jQuery, Javascript",
                location_url: "./web_app/projects/php/pizza/index.html",
                source_code: false
            },
            {
                title: "PHP OOP file downloader",
                img: "./img_projects/php/project3.png",
                desc: "OOP PHP file download.",
                long_desc: `Shows how to download a file via PHP/OOP in four different ways.`,
                topics: "PHP, OOP",
                location_url: "https://github.com/pippo-github/php_downloader_4_ways",
                // location_url: "./web_app/projects/php/php_downloader/index.php", mettere il link a github non permette la creazione di file aruba.it
                source_code: true
            },
            {
                title: "PHP WEB Scraper",
                img: "./img_projects/php/project4.png",
                desc: "PHP OOP web Scraper",
                long_desc: `This application allows the extraction of certain contents from a specific web page through the  Symfony DomCrawler class.`,
                topics: "PHP/OOP",
                location_url: "https://github.com/pippo-github/PHP_WEB_SCRAPLER",
                source_code: true
            }
        ]
    }
]

export {projectsPHP}
